import React from "react";
import { Sparkles, Hand } from "lucide-react";
import { clampBeauty } from "@/lib/liveBeauty";

// Lot 642 — curseur d'intensité du lissage « Beauté » (0 = désactivé … 100), même habillage que le bandeau des filtres.
export const LiveBeautySlider = ({ value, onChange, t }) => (
  <div className="rounded-2xl px-3 py-2.5 space-y-1.5" style={{ background: "rgba(0,0,0,0.5)", border: "1px solid rgba(255,255,255,0.16)" }} data-testid="live-beauty-panel" data-value={value}>
    <div className="flex items-center justify-between text-white">
      <span className="flex items-center gap-1.5 text-xs font-semibold"><Sparkles size={14} /> {t("studio.beauty_intensity", "Lissage de la peau")}</span>
      <span className="text-xs font-bold tabular-nums" data-testid="live-beauty-value">{value === 0 ? t("studio.beauty_none", "Désactivé") : `${value} %`}</span>
    </div>
    <input
      type="range" min={0} max={100} step={1} value={value}
      onChange={(e) => onChange(clampBeauty(e.target.value))}
      aria-label={t("studio.beauty_intensity", "Lissage de la peau")}
      className="w-full h-6 cursor-pointer"
      style={{ accentColor: "#D97757" }}
      data-testid="live-beauty-slider"
    />
    <div className="flex justify-between text-[10px] text-white/60">
      <span>{t("studio.beauty_none", "Désactivé")}</span>
      <span>{t("studio.beauty_max", "Maximum")}</span>
    </div>
    {value > 0 && (
      <p className="text-[11px] text-white/80 flex items-center gap-1.5 pt-0.5" data-testid="live-beauty-hold-hint">
        <Hand size={12} /> {t("studio.beauty_hold_hint", "Maintiens le doigt sur l'image pour comparer sans lissage")}
      </p>
    )}
  </div>
);

export default LiveBeautySlider;
